import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Box, Button, Drawer, Typography } from '@mui/material';
import { Base64 } from 'js-base64';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import languages from '../../../../helpers/utils/languages';
import { DataPanel } from '../create/DataPanel';
import { EditNewTemplate } from '../create/EditNewTemplate';
import OverviewComponent from './OverviewComponent';

export const EditComponent = ({ template, onSave, displayed, onClose }) => {
  const profile = useSelector((state) => state?.login?.profile);
  const [formError, setFormError] = useState({ name: false, settings: false });
  const [isView, setIsView] = useState(false);
  const [defaultContactTypes, setDefaultContactTypes] = useState([]);
  const [defaultStores, setDefaultStores] = useState([]);
  const [defaultLanguage, setDefaultLanguage] = useState([]);
  const [cursorPosition, setCursorPositionProps] = useState(null);

  const [templateData, setTemplateData] = useState({
    templateId: template?._id,
    author: profile?._id,
    name: template?.name,
    service: template?.service?.code,
    contactTypes: [],
    stores: [],
    language: template?.language,
    subject: template?.subject,
    content: template?.base64Template,
    isDraft: template?.isDraft,
    dynamicData: template?.dynamicData,
    attachments: template?.attachments,
    attachmentsSize: 0,
    cursorPosition: 0,
  });

  const handleSave = () => {
    if (templateData?.name === '') {
      setFormError({ ...formError, name: true });
    } else {
      setFormError({ ...formError, name: false });
    }
    if (
      templateData?.contactTypes === null ||
      templateData?.stores === null ||
      templateData?.language === null
    ) {
      setFormError({ ...formError, settings: true });
    } else {
      setFormError({ ...formError, settings: false });
    }
    if (!formError?.name && !formError?.settings) {
      onSave({ ...templateData, id: template?._id });
      console.log('Editing Template', { ...templateData, id: template?._id });
    }
  };

  const handleActivate = () => {
    if (templateData?.name === '') {
      setFormError({ ...formError, name: true });
    } else {
      setFormError({ ...formError, name: false });
    }
    if (
      templateData?.contactTypes === null ||
      templateData?.stores === null ||
      templateData?.language === null
    ) {
      setFormError({ ...formError, settings: true });
    } else {
      setFormError({ ...formError, settings: false });
    }
    if (!formError?.name && !formError?.settings) {
      onSave({
        ...templateData,
        id: template?._id,
        isDraft: false,
      });
      console.log('Editing and activate Template', {
        ...templateData,
        id: template?._id,
        isDraft: false,
      });
    }
  };

  const handleCursorPosition = ({ to, from, editor }) => {
    setCursorPositionProps({ to, from, editor });
  };

  const handleAddDynData = (dynData) => {
    const insert = ` {{${dynData?.label}}} `;

    if (
      cursorPosition?.editor &&
      cursorPosition?.from != null &&
      cursorPosition?.to != null
    ) {
      const ok = cursorPosition?.editor.commands.insertContentAt(
        { from: cursorPosition.from, to: cursorPosition.to },
        insert
      );
      if (!ok) {
        cursorPosition?.editor
          .chain()
          .setTextSelection({
            from: cursorPosition.from,
            to: cursorPosition.to,
          })
          .insertContent(insert)
          .run();
      }
    } else if (cursorPosition?.editor) {
      cursorPosition?.editor.chain().focus().insertContent(insert).run();
    } else {
      return;
    }

    const dataList = [...(templateData?.dynamicData || [])];
    if (
      !dataList.some(
        (item) =>
          item?._id?.toString() === dynData._id?.toString() ||
          item?.toString() === dynData._id?.toString()
      )
    ) {
      dataList.push(dynData?._id);
    }
    setTemplateData({
      ...templateData,
      dynamicData: dataList,
    });
  };

  useEffect(() => {
    const contactTypeList = template?.contactType?.map((type) => {
      return { label: type?.name, id: type?.codeBO };
    });
    const storeList = template?.store?.map((item) => {
      return { label: item.shortName, id: item?._id };
    });
    const languageName = languages?.find(
      ({ code2 }) => code2 === template?.language
    );
    const displayLang = (
      <Typography>
        <span className={`fi fi-${languageName?.flag}`} /> -{' '}
        {languageName?.lang}
      </Typography>
    );
    setDefaultContactTypes(contactTypeList);
    setDefaultStores(storeList);
    setDefaultLanguage({
      label: languageName?.lang,
      id: languageName?.code2,
      display: displayLang,
    });

    let body = null;
    if (template?.base64Template) {
      body = Base64.decode(template?.base64Template);
      body = JSON.parse(body);
    }

    let newAttachmentsSize = 0;
    if (template?.attachments?.length > 0) {
      newAttachmentsSize = template?.attachments?.reduce((acc, curr) => {
        return acc + curr?.size;
      }, 0);
    }

    setTemplateData({
      templateId: template?._id,
      author: profile?._id,
      name: template?.name,
      service: template?.service?.code,
      contactTypes: template?.contactType?.map((item) => item?.codeBO),
      stores: template?.store?.map((item) => item?._id),
      language: template?.language,
      subject: template?.subject,
      dataList: template?.dataList,
      content: body || null,
      isDraft: template?.isDraft,
      attachments: template?.attachments,
      attachmentsSize: newAttachmentsSize,
    });
  }, [template]);

  return (
    <Box>
      <Drawer
        sx={{
          flexShrink: 0,
          display: 'flex',
          flexDirection: 'column',
        }}
        anchor="right"
        open={displayed}
        onClose={onClose}
      >
        <Box
          sx={{
            minWidth: 1500,
            padding: '32px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            height: '100%',
          }}
        >
          <Box>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',

                alignItems: 'center',
                width: '100%',
                borderBottom: 1,
                marginBottom: 3,
                gap: 4,
              }}
            >
              <Button
                sx={{ margin: 3 }}
                startIcon={<ArrowBackIosIcon color="primary" />}
                variant="outlined"
                onClick={onClose}
              >
                Retour
              </Button>
              <Typography
                fontSize={24}
                sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
              >
                <EditIcon fontSize="large" color="primary" />
                {template?.name}
              </Typography>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  alignItems: 'center',
                  gap: 3,
                }}
              >
                <Button
                  variant="outlined"
                  color="primary"
                  size="small"
                  onClick={() => setIsView(true)}
                >
                  <VisibilityIcon />
                </Button>
                <Button
                  variant="outlined"
                  color="primary"
                  size="small"
                  onClick={handleSave}
                >
                  Enregistrer
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  disabled={!template?.isDraft}
                  onClick={handleActivate}
                >
                  Enregistrer et activer
                </Button>
              </Box>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'flex-start' }}>
              <EditNewTemplate
                templateData={templateData}
                setTemplateData={setTemplateData}
                defaultContactTypes={defaultContactTypes}
                defaultStores={defaultStores}
                defaultLanguage={defaultLanguage}
                formError={formError}
                onCursorPosition={handleCursorPosition}
              />
              <DataPanel onClick={handleAddDynData} />
            </Box>
          </Box>

          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              width: '100%',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                p: 1,
                justifyContent: 'center',
              }}
            >
              <Typography component={'p'} sx={{ fontSize: '0.8em' }}>
                Dernière sauvegarde le{' '}
                {new Date(template?.updatedAt).toLocaleString('fr-FR')}
              </Typography>
            </Box>
          </Box>
        </Box>
        <OverviewComponent
          template={templateData}
          onClose={() => setIsView(false)}
          displayed={isView}
        />
      </Drawer>
    </Box>
  );
};
